import React, { useContext, useEffect, useState} from 'react'
import {Modal, ModalBody} from 'reactstrap'
import strings from '../../../lang/strings'
import {observer} from 'mobx-react'
import {formatNumber, string} from '../../../helper/common'
import ConfirmButton from '../button/confirm_button'
import {PAY_ACCOUNT, PAY_BANK, PAY_DEPOSITOR} from '../../../config/const'
import {Page_settings} from '../../../config/page_settings'
import {rootStore} from '../../../mobx/store'
import AppInput from '../custom_input/app_input'

const PayConfirmModal = observer((props) => {
  const context = useContext(Page_settings)
  const {show, toggle, point, vatFee, payer} = props
  const amount = point * (100 + vatFee) / 100
  // let [payer, setPayer] = useState('')
  // let [payerError, setPayerError] = useState('')
  // let [sendSms, setSendSms] = useState(false)
  // let [phone, setPhone] = useState('')
  // let [phoneError, setPhoneError] = useState('')

  // useEffect(() => {
  //   setPayer('')
  //   setPayerError('')
  //   setSendSms(false)
  //   setPhone('')
  //   setPhoneError('')
  // }, [])

  // useEffect(() => {
  //   setPayerError('')
  // }, [payer])

  // useEffect(() => {
  //   setPhoneError('')
  // }, [phone])

  const onConfirm = () => {
    context.post('member/getPoint', {},
      response => {
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
      }
    )
    toggle()
    // if (payer === '') return setPayerError(strings.payer_name_enter)
    // if (sendSms && phone === '') return setPhoneError(strings.invalid_hint)
    // context.post('pay/nobank_request', {amount: amount, point: point, payer: payer, sendSms: sendSms ? 1 : 0, phone: phone},
    //   response => {
    //     let mb = rootStore.getMe
    //     mb.mb_point = response.mb_point
    //     rootStore.signIn(mb)
    //     context.addNotification('', strings.pay_requested)
    //     toggle()
    //   }
    // )
   
  }

  return (
    <Modal isOpen={show} toggle={() => toggle()} className='modal-point-pay'>
      <ModalBody className='wx-370'>
        <div className='modal-header-custom d-center position-relative'>
          <div className='fs-20 sm-fs-18 f-b'>{strings.pay_confirm_title}</div>
          <div className='modal-close-btn d-center position-absolute' onClick={() => toggle()}>
            <img src={'/assets/image/close.png'} alt='' className='modal-close'/>
          </div>
        </div>
        <div className='modal-po-lack ph-30 sm-ph-15 text-center fs-16'>
          <div className='text-left'>{strings.pay_confirm_str1}</div>
          <div className='f-m text-left space-break mt-20'>{string.Format(strings.pay_confirm_str2, formatNumber(point), PAY_BANK, PAY_ACCOUNT, PAY_DEPOSITOR, formatNumber(amount))}</div>
          <div className='f-m text-left mt-5'>
            {strings.pay_price}<span className='f-b fs-20 color-1b7ede'>{formatNumber(amount)}{strings.won}</span>
          </div>
          <div className='f-m text-left mt-5'>
            {strings.pay_payer_name}<span className='f-b fs-20 color-1b7ede'>{payer}</span>
          </div>
          {/* <div className='mt-10'>
            <div className='d-center'>
              <label className='control-label wx-100 text-left mb-0 f-m'>{strings.payer_name}</label>
              <AppInput className='flex-full' errorMsg={payerError} placeholder={strings.payer_name_hint} inputType={'text'} maxLength={20} value={payer} onChange={(v) => { setPayer(v) }} />
            </div>
            <div className='d-center mt-5' hidden={true}>
              <div className='d-flex align-items-center cursor-point' onClick={() => setSendSms(!sendSms)}>
                <img className='checkbox' src={sendSms ? '/assets/image/chk_on.png' : '/assets/image/chk.png'} alt='' />
                <div className='fs-14 color-9e9e9e ml-10'>{strings.send_sms}</div>
              </div>
              <AppInput className='flex-full ml-10' errorMsg={phoneError} placeholder={strings.phone} inputType={'tel'} value={phone} onChange={(v) => { setPhone(v) }} />
            </div>
          </div> */}
          <div className='text-left space-break mt-20 color-fa2222 fs-15 f-m'>{strings.pay_confirm_str3}</div>
          <div className='d-center mt-30 sm-mt-20'>
            {/* <ConfirmButton enabled={true} className={'btn-grey-border fs-15 sm-fs-14 f-m d-center'} onClick={toggle} text={strings.cancel} /> */}
            <ConfirmButton enabled={true} className={'bd-0 btn-primary fs-15 sm-fs-14 f-m d-center'} onClick={onConfirm} text={strings.confirm} />
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
})

export default PayConfirmModal
